<template>
  <content-loader :height="226" :width="750">
    <rect x="0" y="25" rx="0" ry="0" width="180" height="135" />
    <rect x="217" y="25" rx="0" ry="0" width="550" height="165" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
